// TODO: unify in utils ?
import { atom } from 'jotai'
import { z } from 'zod'
import * as http from '@/util/http'

export const ProgramTypeSchema = z.object({
  programType: z.string(),
})

export type ProgramTypeForm = z.input<typeof ProgramTypeSchema>

export const defaultProgramType: ProgramTypeForm = {
  programType: '',
}

export const selectedProgramType = atom<ProgramTypeForm>(defaultProgramType)

export const EduInfoSchema = z.object({
  region: z.string().min(1, '地方を選択してください'),
  prefecture: z.string().min(1, '都道府県を選択してください'),
  schoolId: z.number({ error: '学校を選択してください' }),
  academicProgramId: z.number().optional(),
  academicCourseId: z.number().optional(),
  grade: z.number(),
})

export type EduInfoForm = z.input<typeof EduInfoSchema>

export const DEFAULT_EDU_INFO: EduInfoForm = {
  region: '',
  prefecture: '',
  schoolId: 0,
  academicProgramId: 0,
  academicCourseId: 0,
  grade: 0,
}

export const eduInfoAtom = atom<EduInfoForm>(DEFAULT_EDU_INFO)

export const CourseSchema = z.object({
  id: z.number(),
  name: z.string(),
  isActive: z.boolean(),
})

export const ProgramSchema = z.object({
  id: z.number(),
  name: z.string(),
  programType: z.string(),
  durationYears: z.number(),
  isActive: z.boolean(),
  courses: z.array(CourseSchema).optional().nullable(),
})

export const SchoolSchema = z.object({
  id: z.number(),
  name: z.string(),
  institutionType: z.string(), // z.nativeEnum(Institutiontype)
  adminDivision: z.string(), // z.nativeEnum(Prefecture)
  subnationalUnit: z.string(), // z.nativeEnum(Region)
  programs: z.array(ProgramSchema).optional().nullable(),
})

export const EducationHistorySchema = z.object({
  id: z.number().int(),
  // profileId: z.number().int(),
  programType: z.string(),
  school: SchoolSchema.optional().nullable(),
  academicProgram: ProgramSchema.optional().nullable(),
  academicCourse: CourseSchema.optional().nullable(),
  enrollmentStartDate: z.preprocess((val) => {
    if (typeof val === 'string' || val instanceof Date) return new Date(val)
  }, z.date()),
  enrollmentEndDate: z.string().optional().nullable(),
  extraInfo: z.any().optional().nullable(),
})

export type EducationHistory = z.infer<typeof EducationHistorySchema>

export async function fetchEducationHistory(): Promise<EducationHistory[]> {
  const { data } = await http.get<EducationHistory[]>('/api/v1/user/profile/education-history')
  return EducationHistorySchema.array().parse(data)
}
